import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { notificationsApi } from '@/features/notifications/api/notifications.api'

const LIST_KEY = ['notifications', 'list'] as const
const UNREAD_COUNT_KEY = ['notifications', 'unread-count'] as const

export function useNotificationsQuery(perPage = 20) {
  return useQuery({
    queryKey: [...LIST_KEY, perPage],
    queryFn: () => notificationsApi.list(perPage),
  })
}

export function useUnreadCount() {
  return useQuery({
    queryKey: UNREAD_COUNT_KEY,
    queryFn: notificationsApi.unreadCount,
    staleTime: 60_000,
  })
}

function useInvalidateNotifications() {
  const queryClient = useQueryClient()
  return () => {
    void queryClient.invalidateQueries({ queryKey: LIST_KEY })
    void queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY })
  }
}

export function useMarkRead() {
  const invalidate = useInvalidateNotifications()
  return useMutation({
    mutationFn: notificationsApi.markRead,
    onSuccess: () => invalidate(),
  })
}

export function useMarkAllRead() {
  const invalidate = useInvalidateNotifications()
  return useMutation({
    mutationFn: notificationsApi.markAllRead,
    onSuccess: () => invalidate(),
  })
}

export { LIST_KEY as NOTIFICATIONS_LIST_KEY, UNREAD_COUNT_KEY as NOTIFICATIONS_UNREAD_COUNT_KEY }
